import {useCallback, MouseEvent} from 'react';

import {downloadPdf} from 'features/intercept-file-download-anchor/services/download-pdf';

/**
 * Хук для обработки кликов по измененным ссылкам.
 * Отлавливает клики на `<a>` с параметром `type=external_pdf` и загружает PDF.
 */
export const useHandleExternalLink = () => useCallback((event: MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLAnchorElement;
    if (target.tagName === 'A' && target.href.includes('type=external_pdf')) {
        event.preventDefault();
        downloadPdf(target.href);
    }
}, []);

export type TUseHandleExternalLinkData = ReturnType<typeof useHandleExternalLink>;
